import Black from '../../assets/betgalaxy/fonts/Roboto-Black.ttf';
import BlackItalic from '../../assets/betgalaxy/fonts/Roboto-BlackItalic.ttf';
import Bold from '../../assets/betgalaxy/fonts/Roboto-Bold.ttf';
import BoldItalic from '../../assets/betgalaxy/fonts/Roboto-BoldItalic.ttf';

import ExtraLight from '../../assets/betgalaxy/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '../../assets/betgalaxy/fonts/Roboto-ThinItalic.ttf';
import Light from '../../assets/betgalaxy/fonts/Roboto-Light.ttf';
import LightItalic from '../../assets/betgalaxy/fonts/Roboto-LightItalic.ttf';
import Regular from '../../assets/betgalaxy/fonts/Roboto-Regular.ttf';
import Italic from '../../assets/betgalaxy/fonts/Roboto-Italic.ttf';
import SemiBold from '../../assets/betgalaxy/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '../../assets/betgalaxy/fonts/Roboto-MediumItalic.ttf';
import StrippyRegular from '../../assets/betgalaxy/fonts/Strippy-Regular.ttf';
import ExoBlack from '../../assets/betgalaxy/fonts/Exo-Black.ttf';
import ExoExtraBold from '../../assets/betgalaxy/fonts/Exo-ExtraBold.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }
  @font-face {
    font-family: 'strippy';
    src: url('${StrippyRegular}') format('opentype');
  }
  @font-face {
    font-family: 'Exo';    
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${ExoBlack}') format('opentype');
  }
  @font-face {
    font-family: 'Exo';    
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('${ExoExtraBold}') format('opentype');
  }
`;
